import {HeaderApi} from "./header-api";
import {Inject, Injectable} from "@angular/core";
import {ApiConfig, APP_CONFIG} from "@app-web-central/web/shared/api-config";
import {HttpClient} from "@angular/common/http";
import {CfSuite, ResponseState} from "@app-web-central/web/shared/data-access/models";

@Injectable({providedIn: 'root'})
export class SuiteApi {
  constructor(
    @Inject(APP_CONFIG) private _appConfig: ApiConfig,
    private _header: HeaderApi,
    private _http: HttpClient
  ) {}

  get(unitId: string) {
    return this._http.get<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/${unitId}`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  list() {
    return this._http.get<ResponseState<CfSuite[]>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  create(suite: CfSuite) {
    return this._http.post<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites`, suite, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  update(suiteId: string, suite: CfSuite) {
    return this._http.put<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/${suiteId}`, suite, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  delete(suiteId: string) {
    return this._http.delete<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/${suiteId}`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  deleteBulk(suiteIds: string[]) {
    return this._http.delete<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/bulk/${suiteIds}`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  enable(suiteId: string) {
    return this._http.get<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/${suiteId}/enable`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  enableBulk(suiteIds: string[]) {
    return this._http.post<ResponseState<CfSuite[]>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/bulk/enable`, suiteIds, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  disable(suiteId: string) {
    return this._http.get<ResponseState<CfSuite>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/${suiteId}/disable`, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

  disableBulk(suiteIds: string[]) {
    return this._http.post<ResponseState<CfSuite[]>>(
      `${this._appConfig.generalConfigV1Url}manage/addresses/suites/bulk/disable`, suiteIds, {
        headers: this._header.getServiceHeader(),
        withCredentials: true
      }
    );
  }

}
